// extracted by mini-css-extract-plugin
module.exports = {"link":"style_link__1HHz2","default":"style_default__3RLef","dark":"style_dark__26in2","uppercase":"style_uppercase__2WOzr"};